/**
 * Maps a business profile's Settings rows into a flag map keyed by
 * setting key (e.g. `BusinessProfile.IsStunnrAIEnabled` -> true).
 * Only the string "true" (case-insensitive) counts as enabled.
 * Returns an empty map on missing input.
 */

import type { BpSetting } from '@/types/account/user';

export function parseBpFeatureFlags(
  settings?: BpSetting[] | null
): Record<string, boolean> {
  if (!settings?.length) return {};

  const flags: Record<string, boolean> = {};
  for (const setting of settings) {
    if (!setting?.key) continue;
    flags[setting.key] = setting.value?.trim().toLowerCase() === 'true';
  }
  return flags;
}
